export default function CategoryHeader({ label }) {
  return (
    <div
      data-testid={`category-header-${label}`}
      className="chalkboard-band rounded-xl py-3 px-4 flex items-center justify-center border-2 border-brand-yellow/40 shadow-inner"
    >
      <h2 className="font-display text-brand-yellow text-2xl tracking-wide">
        {label}
      </h2>
    </div>
  );
}
